module.exports = __webpack_public_path__ + "img/checkup-img-coupon@3x.b04e8606.png";